import { GetStartedType } from "components/Navbar/GetStartedButton"
import { graphql } from "gatsby"
import ArticleList from "../Blog/ArticleList"
import CategoryTags from "../Blog/CategoryTags"
import Document from "../Document"
import Footer from "../Footer"
import Layout from "../Layout"
import Navbar from "../Navbar"
import PageWrapper, { PaddingTop } from "../PageWrapper"
import Pagination from "../Blog/Pagination"
import * as React from "react"
import SEO from "../Seo"
import SideNav from "../SideNav"
import styles from "./styles.module.scss"
import SubNavbarResources from "../SubNavbarResources"

interface IProps {
  data: any
  pageContext: any
}

const Index = ({ data, pageContext }: IProps) => {
  const { currentPage, numPages } = pageContext
  const page = currentPage > 1 ? `Page ${currentPage}` : ``
  let title =
    `Mortgage Resources ` + page ? `- ${page}` : "" + ` - Better Mortgage`
  const posts = data.allMdx.edges
  return (
    <>
      <Document title={title}>
        <Navbar getStartedType={GetStartedType.ALWAYS} />
        <SubNavbarResources />
        <SideNav />
        <PageWrapper paddingTop={PaddingTop.SubNavbar}>
          <main id="content" className={styles.main} role="main">
            <CategoryTags />
            <div className={styles.articleList}>
              <div className={styles.pagePadding}>
                <ArticleList posts={posts} />
                <div className={styles.bottomPagination}>
                  {numPages > 1 && (
                    <Pagination currentPage={currentPage} numPages={numPages} />
                  )}
                </div>
              </div>
            </div>
          </main>
        </PageWrapper>
        <Footer />
      </Document>
    </>
  )
}

export default Index

export const postsQuery = graphql`
  query blogIndex($skip: Int!, $limit: Int!) {
    allMdx(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          rawBody
          timeToRead
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            image {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
